
import { Fragment, useState } from "react";

import processApi from "../../api/processApi";
import { dataValidator } from "../../tools/dataValidator";
import useMount from '../../hooks/useMount';
import { getLabel } from "../../tools/Dictionary";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";
import LoadingComponent from "../Commons/LoadingComponent";
import LabelInput from "../Commons/LabelInput";
import FileController from "../Commons/FileController";


const ProcessFileModal = (props) => {

  //Props
  const IsDesktop = props.IsDesktop;
  const Access = props.Access;
  const Id = props.Id;
  const OnCloseModal = props.OnCloseModal;
  const LoadData = props.LoadData;

  //State
  const [form, setForm] = useState(undefined);
  const [error, setError] = useState({});
  const [loading, setLoading] = useState(true);
  const [isUpdate] = useState(Id && Id != 0);
  const [alert, setAlert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm, setConfirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });

  //Variables
  const baseForm = {
    _id: 0,
    name: "",
    description: "",
    label: {
      "EN": "",
      "FR": "",
      "ES": ""
    },
    type: {},
    format: {},
    thumbUrl: "",
    isActive: true
  }


  useMount(() =>
  {
    loadData();
  }, []);


  const loadData = async() => {

    if (isUpdate){

      try{

        setLoading(true);

        let response = await processApi.getProcessFile(Id);

        if (!response.Success)
        {

          let error = new Error()
          error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

          throw error;

        }


        setForm({
          _id: response.Data._id,
          name: response.Data.name,
          description: response.Data.description,
          label: response.Data.label,
          type: response.Data.type,
          format: response.Data.format,
          fileLocation: response.Data.fileLocation,
          isActive: response.Data.isActive,
        });


        


        setLoading(false);

      }catch(err){


        setAlert({
          Title: getLabel("App", "Error"),
          Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
          Confirm: getLabel("App", "Ok"),
          onConfirm: onFatalError,
          Display: true
        });

      }

    }else{
      //Add
      setForm(baseForm);
      setLoading(false);
    }

  };

  const onFatalError = async() => {

    setAlert(alert => ({ ...alert, Display: false }));

    await LoadData();

    setLoading(false);

    OnCloseModal();

  };

  const onChangeName = (e) => {

    let name = e.target.value;

    onValidateField("name", name); //Validate field value

    setForm(form => ({
      ...form,
      name
    }));
  };

  const onChangeDescription = (e) =>
  {

    let description = e.target.value;


    onValidateField("description", description); //Validate field value

    setForm(form => ({
      ...form,
      description
    }));
  };

  const onChangeLabel = (_value, _field) =>
  {

    onValidateField("label", _value); //Validate field value

    setForm(form => ({
      ...form,
      label: _value
    }));


  };

  const onChangeFile = (_file) => 
  {

    try
    {


      onValidateField("file", _file); //Validate field value

      setForm(form => ({
        ...form,
        type: _file.type,
        file: _file
      }));

    } catch (err)
    {

      setLoading(false);

      setForm(form => ({
        ...form,
        type: "",
        file: undefined
      }));

      setAlert({
        Title: "Erreur",
        Message: err.message || "Désolé, une erreur inconnue est survenue. Veuillez réessayer ultérieurement ou contacter notre équipe de support pour obtenir de l'aide.",
        Confirm: "Ok",
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });


    }
    
  }

  const onChangeActif = () => {

    setForm(form => ({
      ...form,
      isActive: !form.isActive
    }));

  };


  // Validate field
  const onValidateField = (field = "", value = "") =>
  {
    let currentError = { ...error }; // Create a copy of the error object

    let Validation = []; // Array to store validation results
    let currentValidation = [];
    let currentField = "";

    let isValid = true; // Flag to track overall validity

    currentField = "name";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "max:100"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }

    currentField = "description";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["max:100"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }


    currentField = "label";
    if (field == "" || field == currentField)
    {
      let currentValue = field ? value : form[currentField];

      // Validate
      currentValidation = dataValidator([
        { field: currentField, value: currentValue, listValidation: ["required", "label"] }
      ]);

      Validation = [...Validation, ...currentValidation];

    }


    Validation.forEach(validation =>
    {
      // Iterate over each validation result
      if (validation.valid)
      {
        currentError[validation.field] = ""; // If valid, clear the corresponding error field
      } else
      {
        currentError[validation.field] = validation.reason; // If invalid, set the error reason in the corresponding field
        isValid = false; // Set isValid to false if any validation fails
      }
    });

    setError(currentError); // Update the error state

    return isValid; // Return the overall validity flag
  };


  const onClickDelete = () => {

    setConfirm(confirm => ({
      Title: getLabel("App", "Delete"),
      Message: getLabel("ProcessFile", "Are you certain you wish to proceed..."),
      Cancel: getLabel("App", "No"),
      onCancel: () => setConfirm(confirm => ({ ...confirm, Display: false })),
      Confirm: getLabel("App", "Yes"),
      onConfirm: onDelete,
      Display: true
    }));

  };

  const onDelete = async() => {

    try
    {

      setConfirm(confirm => ({ ...confirm, Display: false }))

      setLoading(true);

      let response = await processApi.deleteProcessFile(Id);

      if (!response.Success)
      {

        let error = new Error("");
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      await LoadData();

      OnCloseModal();



    } catch (err)
    {
      await LoadData();

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: OnCloseModal,
        Display: true
      });

    };   

  }

  const onClickSave = async() => {

    if (!onValidateField()){

      return;
    }

    try{

      await onSave();

      await LoadData();

      OnCloseModal();


    }catch(err){

      setLoading(false);

    }


  }

  const onSave = async() => {

    try{

      setLoading(true);


      let formWithFile = new FormData();

      formWithFile.append("_id", form._id);
      formWithFile.append("name", form.name);
      formWithFile.append("description", form.description);
      formWithFile.append("label", JSON.stringify(form.label));
      formWithFile.append("file", form.file);
      formWithFile.append("isActive", form.isActive);


      let response = await processApi.updateProcessFile(formWithFile);

      if (!response.Success){

        let error = new Error()
        error.message = response.Error && response.Error.component ? getLabel(response.Error.component, response.Error.label) : undefined;

        throw error;

      }

      return response.Data;


    }catch(err){

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };

  const onClickDownload = async() => {

    try{


      let response = await processApi.downloadProcessFile(form._id);

      const blob = new Blob([response], {
        type: 'application/octet-stream'
      });

      

      let url = URL.createObjectURL(blob);

      // Create an anchor element
      const a = document.createElement('a');
      a.href = url;
      a.download = form.name + "." + form.format; 

      // Append the anchor element to the document body
      document.body.appendChild(a);

      // Programmatically trigger a click event on the anchor element to initiate the download
      a.click();

      // Cleanup: Remove the anchor element and revoke the temporary URL
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

    } catch (err)
    {

      setLoading(false);

      setAlert({
        Title: getLabel("App", "Error"),
        Message: err.message || getLabel("App", "Sorry, an unknown error has occurred. Please try again later or contact our support team for assistance."),
        Confirm: getLabel("App", "Ok"),
        onConfirm: () => setAlert(alert => ({ ...alert, Display: false })),
        Display: true
      });

      throw err;

    };

  };


  if (!form) return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
          isCover={true}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ProcessFile", "Process File")}
        </div>
        <div className="page_modal_body_cont" />
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={OnCloseModal}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );



  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "900px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
          isCover={true}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{marginBottom: "10px"}}>
          {getLabel("ProcessFile", "Process File")}
        </div>
        <div className="page_modal_body_cont">
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_ProcessFile", "name")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["name"] ? "page_modal_body_col_input_error" : "")}
                value={form.name || ""}
                onChange={onChangeName}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
              />
              {error["name"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["name"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_ProcessFile", "description")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <input
                className={"page_text_input " + (error["description"] ? "page_modal_body_col_input_error" : "")}
                value={form.description || ""}
                onChange={onChangeDescription}
                type="text"
                style={{ width: "100%" }}
                disabled={!Access.canWrite || loading}
              />
              {error["description"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["description"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_ProcessFile", "label")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "600px" }} >
              <LabelInput
                ReadOnly={!Access.canWrite}
                Data={form.label}
                ListValidation={["max:1000"]}
                TextStyle={{ height: "100px" }}
                PreviewMaxLength={400}
                Property={"label"}
                OnChangeValue={onChangeLabel}
                Autofill={{
                  value: form.name,
                  property: getLabel("T_ProcessFile", "name")
                }}
              />
              {error["label"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["label"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_ProcessFile", "file")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "400px" }} >
              <FileController
                IsDesktop={IsDesktop}
                OnFileChange={onChangeFile}
                FileName={form.name}
                FileExtention={form.format}
                FileLocation={form.fileLocation}
                FileType={form.type}
                OnClick={onClickDownload}
              />
              {error["description"] &&
                <div className="page_modal_body_col_extra page_modal_body_col_error">
                  {error["description"]}
                </div>
              }
            </div>
          </div>
          <div className="page_modal_body_row">
            <div className="page_modal_body_col_title">
              {getLabel("T_ProcessFile", "isActive")}
            </div>
            <div className="page_modal_body_col_value" style={{ width: "300px" }} >
              <label className="page_switch">
                <input
                  type="checkbox"
                  checked={form.isActive}
                  onChange={onChangeActif}
                  disabled={!Access.canWrite || loading}
                />
                <span className="page_slider round" />
              </label>
            </div>
          </div>
          
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />
          {!!Access.canWrite &&
            <Fragment>
            {isUpdate == true &&
                <input
                  type="button"
                  className="page_button page_modal_footer_button"
                  value={getLabel("App", "Delete")}
                  style={{ backgroundColor: "#b30000", maxWidth: "200px" }}
                  onClick={(loading && !OnCloseModal) ? undefined : onClickDelete}
                  disabled={loading}
                />
            }
            <input
              type="button"
              className="page_button page_modal_footer_button"
              value={getLabel("App","Save")}
              style={{ backgroundColor: "#52a3e7", maxWidth: "200px" }}
              onClick={(loading) ? undefined : onClickSave}
              disabled={loading}
            />
            </Fragment>
          }
        </div>
      </div>
    </div>
  );

};

export default ProcessFileModal;